import * as z from "zod";
import type { Ctx } from "../../types";
import { FormAction, invalidate, removeQueryParams } from "gg-wf-scripts";
import { toast } from "../../toast";
import { array_field, invokeApi, parse, role_enum } from "../_helpers";

const invite_user_schema = z
  .object({
    email: z.email("Please enter a valid email"),
    first_name: z.string().optional(),
    last_name: z.string().optional(),
    phone: z.string().optional(),
    role: role_enum.optional(),
    schools: array_field(z.uuid("Please select valid Schools")).optional(),
  })
  .refine((d) => d.role !== "school_admin" || (d.schools?.length ?? 0) > 0, {
    path: ["schools"],
    message: "Please select at least one School",
  });

export const invite_user: FormAction<Ctx> = async (
  { sb },
  formData,
  _params
) => {
  const parsed = parse(invite_user_schema, formData);
  if (!parsed.ok) return parsed;

  const result = await invokeApi(sb, "api/users/invite", {
    method: "POST",
    body: parsed.data,
  });
  if (!result.ok) {
    if (result.status === 409) {
      toast({ variant: "warning", text: "User already invited." });
    }
    return result;
  }
  invalidate("users");
  removeQueryParams(["modal", "id"]);
  toast({ variant: "success", text: "Invite sent!" });
  return result;
};
